import { inject, Injectable } from '@angular/core';
import { StorageService } from './storage.service';

const ONBOARDING_COMPLETED_KEY = 'onboardingCompleted';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
  private readonly storageService = inject(StorageService);

  async isOnboardingCompleted(): Promise<boolean> {
    const value = await this.storageService.get(ONBOARDING_COMPLETED_KEY);
    return value === '1';
  }

  isOnboardingCompletedSync(): boolean {
    return this.storageService.getSync(ONBOARDING_COMPLETED_KEY) === '1';
  }

  markOnboardingCompleted(): void {
    this.storageService.setSync(ONBOARDING_COMPLETED_KEY, '1');
  }
}
